import musharakahContent from '../assets/resources/musharakah-partnership-financing-1-content.json';
import ijarahContent from '../assets/resources/ijarah-islamic-leasing-content.json';

function packageFromContent(slug, content, extras = {}) {
  const modules = Array.isArray(content.modules) ? content.modules : [];
  const freeModuleCount = modules.filter((m) => m.free).length || 1;

  return {
    slug,
    title: content.title,
    subtitle: content.subtitle,
    description: content.description,
    audience: content.audience || 'all',
    tags: content.tags || ['Islamic Finance'],
    modules,
    modulesCount: modules.length,
    duration: extras.duration || '~45 min',
    freeModuleCount,
    featured: extras.featured !== false,
    price: extras.price ?? 0,
    priceLabel: extras.priceLabel ?? 'Free',
    compareAtPrice: extras.compareAtPrice ?? 149,
    compareAtPriceLabel: extras.compareAtPriceLabel ?? '$149',
    ...extras,
  };
}

/** Public packages — bundled content.json, no S3 fetch. */
const LOCAL_PACKAGES = [
  packageFromContent('musharakah-partnership-financing-1', musharakahContent),
  packageFromContent('ijarah-islamic-leasing', ijarahContent, {
    duration: '~50 min',
  }),
];

export function getLocalResourceCatalog() {
  return LOCAL_PACKAGES.map(({ modules, ...meta }) => ({
    ...meta,
    modulesCount: meta.modulesCount ?? modules.length,
  }));
}

export function getLocalResourcePackage(slug) {
  return LOCAL_PACKAGES.find((p) => p.slug === slug) ?? null;
}
